// coaFieldConfig.js
// Single source of truth for all cannabinoid and terpene field definitions.
// Each entry: { key: DB column name, label: display label }

export const MAJOR_CANNABINOIDS = [
    { key: "THCa",        label: "THCa" },
    { key: "delta_9_THC", label: "D9 THC" },
    { key: "D8_THC",      label: "D8 THC" },
    { key: "THCV",        label: "THCV" },
    { key: "THCVa",       label: "THCVa" },
    { key: "CBDA",        label: "CBDa" },
    { key: "CBD",         label: "CBD" },
    { key: "CBDV",        label: "CBDV" },
    { key: "CBDVA",       label: "CBDVa" },
    { key: "CBGa",        label: "CBGa" },
    { key: "CBG",         label: "CBG" },
    { key: "CBCa",        label: "CBCa" },
    { key: "CBC",         label: "CBC" },
    { key: "CBN",         label: "CBN" },
    { key: "CBNA",        label: "CBNa" },
    { key: "CBGVA",       label: "CBGVa" },
];

export const MINOR_CANNABINOIDS = [
    { key: "CBL",         label: "CBL" },
    { key: "CBE",         label: "CBE" },
    { key: "CBT",         label: "CBT" },
    { key: "CBND",        label: "CBND" },
    { key: "CBV",         label: "CBV" },
    { key: "THCP",        label: "THCp" },
    { key: "CBDP",        label: "CBDp" },
    { key: "CBDH",        label: "CBDH" },
    { key: "THCH",        label: "THCH" },
    { key: "Delta_10_THC",label: "Delta-10 THC" },
    { key: "THC_O",       label: "THC-O" },
    { key: "HHC",         label: "HHC" },
    { key: "THC_B",       label: "THC-B" },
];

export const SYNTHETIC_CANNABINOIDS = [
    { key: "JWH_018",         label: "JWH-018" },
    { key: "AM_694",          label: "AM-694" },
    { key: "RCS_4",           label: "RCS-4" },
    { key: "WIN_48_098",      label: "WIN 48,098" },
    { key: "CP_47_497",       label: "CP 47,497" },
    { key: "JWH_019",         label: "JWH-019" },
    { key: "JWH_073",         label: "JWH-073" },
    { key: "JWH_081",         label: "JWH-081" },
    { key: "JWH_122",         label: "JWH-122" },
    { key: "JWH_210",         label: "JWH-210" },
    { key: "AM_2201",         label: "AM-2201" },
    { key: "JWH_203",         label: "JWH-203" },
    { key: "JWH_250",         label: "JWH-250" },
    { key: "RCS_8",           label: "RCS-8" },
    { key: "AKB48",           label: "AKB48" },
    { key: "UR_144",          label: "UR-144" },
    { key: "XLR11",           label: "XLR11" },
    { key: "PB_22",           label: "PB-22" },
    { key: "5F_PB_22",        label: "5F-PB-22" },
    { key: "5F_AKB_48",       label: "5F-AKB-48" },
    { key: "HU_210",          label: "HU-210" },
    { key: "AB_FUBINACA",     label: "AB-FUBINACA" },
    { key: "AB_PINACA",       label: "AB-PINACA" },
    { key: "MDMB_CHMICA",     label: "MDMB-CHMICA" },
    { key: "5F_MDMB_PICA",    label: "5F-MDMB-PICA" },
    { key: "4F_MDMB_BINACA",  label: "4F-MDMB-BINACA" },
    { key: "5F_CUMYL_PINACA", label: "5F-CUMYL-PINACA" },
];

// All 44 terpene fields, ordered by prevalence (most common first)
export const ALL_TERPENES = [
    { key: "Myrcene",                      label: "Myrcene" },
    { key: "beta_caryophyllene",           label: "Beta Caryophyllene" },
    { key: "Limonene",                     label: "Limonene" },
    { key: "alpha_pinene",                 label: "Alpha Pinene" },
    { key: "beta_pinene",                  label: "Beta Pinene" },
    { key: "Linalool",                     label: "Linalool" },
    { key: "Terpinolene",                  label: "Terpinolene" },
    { key: "alpha_humulene",               label: "Humulene" },
    { key: "Ocimene",                      label: "Ocimene" },
    { key: "caryophyllene_oxide",          label: "Caryophyllene Oxide" },
    { key: "Nerolidol",                    label: "Nerolidol" },
    { key: "Bisabolol",                    label: "Bisabolol" },
    { key: "terpineol",                    label: "Terpineol" },
    { key: "Geraniol",                     label: "Geraniol" },
    { key: "Camphene",                     label: "Camphene" },
    { key: "alpha_terpinene",              label: "Alpha Terpinene" },
    { key: "gamma_terpinene",              label: "Gamma Terpinene" },
    { key: "Nerol",                        label: "Nerol" },
    { key: "fenchone",                     label: "Fenchone" },
    { key: "Eucalyptol",                   label: "Eucalyptol" },
    { key: "Valencene",                    label: "Valencene" },
    { key: "Borneol",                      label: "Borneol" },
    { key: "Sabinene",                     label: "Sabinene" },
    { key: "delta_3_carene",               label: "Delta-3-Carene" },
    { key: "Guaiol",                       label: "Guaiol" },
    { key: "Fenchol",                      label: "Fenchol" },
    { key: "Farnesene",                    label: "Farnesene" },
    { key: "Elemene",                      label: "Elemene" },
    { key: "Isoborneol",                   label: "Isoborneol" },
    { key: "Isopulegol",                   label: "Isopulegol" },
    { key: "Menthol",                      label: "Menthol" },
    { key: "Pulegone",                     label: "Pulegone" },
    { key: "Phytol",                       label: "Phytol" },
    { key: "alpha_bisabolene",             label: "Alpha Bisabolene" },
    { key: "beta_bisabolene",              label: "Beta Bisabolene" },
    { key: "Cedrene",                      label: "Cedrene" },
    { key: "Bergamotene",                  label: "Bergamotene" },
    { key: "Aristolene",                   label: "Aristolene" },
    { key: "Selina_diene",                 label: "Selina-Diene" },
    { key: "trans_sesquisabinene_hydrate", label: "Trans-Sesquisabinene Hydrate" },
    { key: "gamma_elemene",                label: "Gamma Elemene" },
    { key: "beta_maaliene",                label: "Beta Maaliene" },
    { key: "Bulnesol",                     label: "Bulnesol" },
    { key: "Chamigrene",                   label: "Chamigrene" },
];
